import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

// 抽卡记录接口
export interface CardDrawRecord {
  id: number;
  user_id: number;
  user?: {
    id: number;
    nickname: string;
    mobile: string;
  };
  card_pool_id: number;
  card_pool?: {
    id: number;
    name: string;
  };
  card_id: number;
  card?: {
    id: number;
    name: string;
    image: string | null;
    rarity: string;
    rarity_display?: string;
  };
  card_series_id: number;
  card_series?: {
    id: number;
    name: string;
  };
  price: number;
  energy_cost: number;
  is_guaranteed: boolean;
  draw_count: number;
  payment_record_id: number | null;
  created_at: string;
}

// 抽卡统计接口
export interface CardDrawStatistics {
  total_draws: number;
  total_revenue: number;
  total_energy_consumed: number;
  guaranteed_draws: number;
  unique_users: number;
  pool_stats: Array<{
    card_pool_id: number;
    card_pool_name: string;
    draw_count: number;
  }>;
  rarity_distribution: Array<{
    rarity: string;
    rarity_display: string;
    count: number;
    percentage: number;
  }>;
  daily_draws: Array<{
    date: string;
    count: number;
    revenue: number;
  }>;
}

@Module
export default class CardDrawRecordModule extends VuexModule {
  card_draw_records_list = [] as Array<CardDrawRecord>;
  card_draw_records_count = 0;
  card_draw_record = {} as CardDrawRecord;
  card_draw_statistics = {} as CardDrawStatistics;

  get currentCardDrawRecordsList(): Array<CardDrawRecord> {
    return this.card_draw_records_list;
  }

  get currentCardDrawRecord(): CardDrawRecord {
    return this.card_draw_record;
  }

  get currentCardDrawRecordsCount(): number {
    return this.card_draw_records_count;
  }

  get currentCardDrawStatistics(): CardDrawStatistics {
    return this.card_draw_statistics;
  }

  @Mutation
  [Mutations.SET_CARD_DRAW_RECORDS_LIST](records_list: Array<CardDrawRecord>) {
    this.card_draw_records_list = records_list;
  }

  @Mutation
  [Mutations.SET_CARD_DRAW_RECORD](record: CardDrawRecord) {
    this.card_draw_record = record;
  }

  @Mutation
  [Mutations.SET_CARD_DRAW_RECORDS_COUNT](count: number) {
    this.card_draw_records_count = count;
  }

  @Mutation
  [Mutations.SET_CARD_DRAW_STATISTICS](statistics: CardDrawStatistics) {
    this.card_draw_statistics = statistics;
  }

  @Action
  [Actions.GET_CARD_DRAW_RECORDS](params: Record<string, unknown>) {
    ApiService.setHeader();

    let queryString = "?";
    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
          queryString += "&" + key + "=" + params[key];
        }
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/card_draw_records", queryString)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_CARD_DRAW_RECORDS_LIST, data["card_draw_records"] || []);
          this.context.commit(Mutations.SET_CARD_DRAW_RECORDS_COUNT, data["total_result"] || 0);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }

  @Action
  [Actions.GET_CARD_DRAW_RECORD](id: number) {
    ApiService.setHeader();

    return new Promise<void>((resolve, reject) => {
      ApiService.get(`admin/card_draw_records/${id}`)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_CARD_DRAW_RECORD, data["card_draw_record"]);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }

  @Action
  [Actions.GET_CARD_DRAW_STATISTICS](params?: Record<string, unknown>) {
    ApiService.setHeader();

    let queryString = "?";
    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
          queryString += "&" + key + "=" + params[key];
        }
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/card_draw_records/statistics", queryString)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_CARD_DRAW_STATISTICS, data["statistics"] || {});
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }
}
